// Dubai - AC gas refill.
const content = {
    slug: 'ac-gas-refill',
    title: (c) => `AC Gas Refill Dubai from ${c.money(c.tables.gas.R410A.half)} | R410A, R32, R22`,
    description: (c) =>
        `AC gas refill in Dubai: R410A top-up ${c.money(c.tables.gas.R410A.half)}, R32 ${c.money(c.tables.gas.R32.half)} per outdoor unit. Pressure checked first; leaks found before refilling.`,
    eyebrow: 'Dubai · AC gas refill',
    h1: 'AC Gas Refill in Dubai',
    lead: (c) =>
        `A sealed AC should not need gas every summer. When it does lose pressure, we check why before refilling - then top up R410A, R32 or R22 at a fixed price per outdoor unit, from ${c.money(c.tables.gas.R410A.half)}.`,
    image: 'blog/living/aircon-gas.jpg',
    imageAlt: 'Technician checking AC refrigerant pressure with gauges',
    facts: ['Pressure test first', 'R410A, R32 and R22', 'Priced per outdoor unit'],
    priceTitle: 'Gas refill prices',
    priceIntro: 'Choose the refrigerant on your outdoor unit\'s label, and whether you need a top-up or a full refill. If you are unsure, pick R410A top-up - the technician confirms on site before charging anything extra.',
    panel: { type: 'gas' },
    sections: [
        {
            title: 'Does your AC actually need gas?',
            cards: [
                { title: 'Likely low gas', body: 'Ice or frost on the copper pipe at the outdoor unit, hissing near the pipes, or the unit blowing barely cool air even after a fresh cleaning.' },
                { title: 'Probably not gas', body: 'Weak airflow, a smell, or one room colder than another. Those are usually a dirty filter or coil - a cleaning costs less and fixes more.' },
                { title: 'Never gas', body: 'District-cooled apartments. Your unit runs on chilled water from the building, so there is no refrigerant to refill.' },
            ],
        },
        {
            title: 'Why units in Dubai lose gas',
            tone: 'muted',
            paragraphs: [
                'Refrigerant only escapes through a leak. In Dubai the usual culprits are flare joints loosened by years of vibration and heat cycling, corrosion on outdoor coils near the sea, and pipes damaged during renovation or when a unit was moved.',
                'Topping up without finding the leak means paying again next summer. The technician checks the joints and the outdoor coil with leak detector before refilling, and quotes any repair separately so you can decide.',
            ],
        },
        {
            title: 'Which refrigerant does your unit use?',
            paragraphs: [
                'Look at the rating label on the side of the outdoor unit. Most units installed in Dubai in the last ten to fifteen years use R410A. Newer inverter models increasingly use R32. R22 is found only in older units and is being phased out, so it costs more and gets harder to source each year.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much does an AC gas refill cost in Dubai?',
            answer: (c) => `A top-up costs ${c.money(c.tables.gas.R410A.half)} for R410A, ${c.money(c.tables.gas.R32.half)} for R32 and ${c.money(c.tables.gas.R22.half)} for R22, per outdoor unit. A full refill after a repair costs ${c.money(c.tables.gas.R410A.full)} for R410A.`,
        },
        {
            question: 'How often does an AC need gas?',
            answer: 'In a healthy system, never - refrigerant circulates in a sealed loop. Needing gas every year means there is a leak worth finding and fixing.',
        },
        {
            question: 'Can you refill gas in my district-cooled apartment?',
            answer: 'No. District-cooled apartments use chilled water, not refrigerant. If it is not cooling, book a cleaning or a repair diagnosis instead.',
        },
        {
            question: 'Is R22 still allowed in the UAE?',
            answer: 'R22 is being phased out under the international Montreal Protocol, so supply is shrinking and prices are rising. Existing units can still be serviced, but replacing an R22 unit that leaks repeatedly is often better value.',
        },
    ],
    schema: {
        name: 'AC Gas Refill in Dubai',
        serviceType: 'Air conditioner refrigerant recharge',
        offers: (c) => [
            { name: 'R410A gas top-up, 1 outdoor unit', price: c.tables.gas.R410A.half },
            { name: 'R410A full refill, 1 outdoor unit', price: c.tables.gas.R410A.full },
            { name: 'R32 gas top-up, 1 outdoor unit', price: c.tables.gas.R32.half },
            { name: 'R22 gas top-up, 1 outdoor unit', price: c.tables.gas.R22.half },
        ],
    },
}

export default content
